/**
 * @generated SignedSource<<58f61b310b4bd453886b86451b034f28>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespBuyerAssuranceBox_user$data = {
  readonly isVerifiedTrade: boolean | null;
  readonly " $fragmentType": "PdpRespBuyerAssuranceBox_user";
};
export type PdpRespBuyerAssuranceBox_user$key = {
  readonly " $data"?: PdpRespBuyerAssuranceBox_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespBuyerAssuranceBox_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespBuyerAssuranceBox_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "5442a9fcd76f6f65e644d9f0d377c9f9";

export default node;
